<template>
  <v-btn @click="exportxlsx" :loading="loading" color="grey" outline>
    <em class="fas fa-file-export"></em>
    &nbsp;
    {{ $t('export') }}&nbsp;
  </v-btn>
</template>

<script>
import XLSX from 'xlsx'
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
      require: true
    },
    promisedValue: {
      type: Function
    },
    filename: {
      type: String,
      default: 'exportedfile'
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async exportxlsx() {
      this.loading = true
      if (this.promisedValue) {
        var json = await this.promisedValue()
      } else {
        var json = this.value
      }

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, this.filename + '.xlsx')
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/exportxlsx.vue